const chargingApproaches = [
  {id: 'Even', translationKey: 'chargers.chargingApproaches.even'},
  {id: 'Max', translationKey: 'chargers.chargingApproaches.max'},
];

export default chargingApproaches;
